import React from 'react'
import { FaQuoteRight } from 'react-icons/fa'
import './By.css'

const By = ({image, name, position}) => {
    return (
        <div className="by">
            <div className="by-image">
                <img className="by-image" src={image} alt="person" />
                <FaQuoteRight className="quote-icon" />
            </div>
            <div className="by-info">
                <h3>{name}</h3>
                <p>{position}</p>
            </div>
        </div>
    )
}

export default By
